import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import { ICryptoSealsAttribute } from '../../CryptoSeals/ICryptoSeals'
import Api from '../../../../../services/Api'
import { useGetTokenUri } from '../../../../../hooks/useNFTMarketPlace'
import INFTProperties from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IMooseCard } from '../Card/IMooseCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function MooseDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IMooseCard | null>(null)
  const tokenUri = useGetTokenUri(collection.tokenAddress, tokenItem?.tokenId)

  useEffect(() => {
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: ICryptoSealsAttribute) => ({
        key: item.trait_type,
        value: item.value,
        show: true
      }))
    }

    return result
  }

  return (
    <BaseDetail {...props} properites={getNFTProperties()}>
      {detailTokenItem ? <img src={detailTokenItem.image} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
